import {
    CREATE_STATE_MASTER_FAILURE,
    CREATE_STATE_MASTER_REQUEST,
    CREATE_STATE_MASTER_SUCCESS,
    CREATE_USER_FORM_STATE_MASTER,
    DELETE_STATE_MASTER_FAILURE,
    DELETE_STATE_MASTER_REQUEST,
    DELETE_STATE_MASTER_SUCCESS,
    FETCH_SINGLE_STATE_MASTER_FAILURE,
    FETCH_SINGLE_STATE_MASTER_REQUEST,
    FETCH_SINGLE_STATE_MASTER_SUCCESS,
    FETCH_STATE_MASTER_FAILURE,
    FETCH_STATE_MASTER_REQUEST,
    FETCH_STATE_MASTER_SUCCESS,
    STATE_MASTER_USERFORM_RESET,
    UPDATE_STATE_MASTER_FAILURE,
    UPDATE_STATE_MASTER_REQUEST,
    UPDATE_STATE_MASTER_SUCCESS
} from './stateMaster.actionsType';

export const STATE_MASTER = 'stateMaster';

let initialState = {
    loading: false,
    stateMaster: [],
    ipAddressInfo: null,
    selectedState: {},
    userform: {},
    errorMessage: ''
};

export let stateMasterReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_STATE_MASTER_REQUEST:
        case CREATE_STATE_MASTER_REQUEST:
        case UPDATE_STATE_MASTER_REQUEST:
        case FETCH_SINGLE_STATE_MASTER_REQUEST:
        case DELETE_STATE_MASTER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_STATE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                stateMaster: updatePayload
            };
        case CREATE_USER_FORM_STATE_MASTER:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case CREATE_STATE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {}
            };
        case UPDATE_STATE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedState: {},
                userform: {}
            };
        case FETCH_SINGLE_STATE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedState: payload,
                userform: {
                    stateCode: payload.fldStateCode,
                    stateName: payload.fldStateName,
                    shortName: payload.fldShortName
                }
            };
        case DELETE_STATE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case STATE_MASTER_USERFORM_RESET:
            return {
                ...state,
                selectedState: {},
                userform: {}
            };
        case FETCH_STATE_MASTER_FAILURE:
        case CREATE_STATE_MASTER_FAILURE:
        case UPDATE_STATE_MASTER_FAILURE:
        case FETCH_SINGLE_STATE_MASTER_FAILURE:
        case DELETE_STATE_MASTER_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: payload
            };
        default:
            return state;
    }
};
